<template>
    <div class="image-rotator" :style="{height: imgHeight}" :class="{'image-rotator--with-descriptions': hasDescriptions}">
        <button @click="prevImage" class="image-rotator__btn image-rotator__btn--prev">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 223 395.65"><path d="M223,370.5a25,25,0,0,0-7.37-17.79L73.49,210.57,60.76,197.84l12.73-12.73L215.63,43A25.16,25.16,0,1,0,180,7.38L7.37,180a25.16,25.16,0,0,0,0,35.58L180,388.29a25.17,25.17,0,0,0,43-17.79Z"/></svg>
        </button>
        <carousel :per-page="1" :navigate-to="[shownImage, animate]" :pagination-enabled="paginationEnabled" @pageChange="onPageChange" :style="{height: imgHeight}">
            <slide v-for="(slide, slideKey) in shownSlides" :key="slideKey" @slideclick="onClick" :data-index="slideKey">
                <div class="image-rotator__img" :style="{'background-image': getBackgroundImagetag(slide.image)}" v-if="thumbnail"></div>
                <template v-else>
                    <p class="slide-description" v-if="slide.description" v-text="slide.description"></p>
                    <img v-if="slide.type == 'image'" :src="getImagetag(slide.image)" ref="imgElements" class="image-rotator__img" @load="readImgHeight">
                    <div v-if="slide.type == 'video'"  class="image-rotator__vid">
                        <iframe :src="slide.url" style="width: 100%; height: 100%;"></iframe>
                    </div>
                </template>
            </slide>
        </carousel>

        <button @click="nextImage" class="image-rotator__btn image-rotator__btn--next">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 223 395.65"><path d="M223,370.5a25,25,0,0,0-7.37-17.79L73.49,210.57,60.76,197.84l12.73-12.73L215.63,43A25.16,25.16,0,1,0,180,7.38L7.37,180a25.16,25.16,0,0,0,0,35.58L180,388.29a25.17,25.17,0,0,0,43-17.79Z"/></svg>
        </button>
        <button class="image-rotator__heliview-btn" v-if="showHeliviewBtn" @click="$emit('heliviewclick')">
            <img src="./../../img/icons/icon-heliview.svg" class="image-rotator__heliview-icon">
        </button>
    </div>
</template>

<script type="text/javascript">
    import { Carousel, Slide } from 'vue-carousel/src/index.js';
    export default {
        props: {
            images: {type: [Object, Array], default() {return [ ]}},
            videos: {type: [Object, Array], default() {return [ ]}},
            startImage: {type: Number, default: null},
            thumbnail: {type: Boolean, default: true},
            paginationEnabled: {type: Boolean, default: false},
            showHeliviewBtn: {type: Boolean, default: false},
            enableKeys: {type: Boolean, default: false}
        },
        data() {
            return {
                shownImage: 0,
                animate: false,
                imgHeight: 'auto'
            }
        },
        mounted() {
            this.disableAnimation();
            this.shownImage = (this.startImage) ? this.startImage : 0;
            this.enableAnimation(true);

            setTimeout(() => {
                this.disableAnimation();
                this.shownImage = (this.startImage) ? this.startImage : 0;
                this.enableAnimation(true);
            }, 500);

            if(this.enableKeys) {
                this.addKeyEventListeners();
            }
        },
        beforeDestroy() {
            if(this.enableKeys) {
                this.removeKeyEventListeners();
            }
        },
        watch: {
            shownImage() {
                this.readImgHeight();
            }
        },
        methods: {
            addKeyEventListeners() {
                console.log('Add key event listener');
                window.addEventListener('keydown', this.onKeyDown);
            },
            removeKeyEventListeners() {
                console.log('Remove key event listener');
                window.removeEventListener('keydown', this.onKeyDown);
            },
            onKeyDown(e) {
                switch(e.keyCode) {
                    case 39:
                        this.nextImage();
                        break;
                    case 37:
                        this.prevImage();
                        break;
                }
            },
            onPageChange(slide) {
                if(!isNaN(slide)) {
                    this.shownImage = slide;
                }
            },
            onClick(image) {
                this.$emit('show', this.shownImage);
            },
            prevImage() {
                let prevImage = this.shownImage - 1;
                if(prevImage < 0) {
                    this.disableAnimation();
                    this.$nextTick(() => {
                        this.shownImage = this.shownSlides.length - 1;
                        this.enableAnimation(true);
                    });
                } else {
                    this.enableAnimation(true);
                    this.$nextTick(() => {
                        this.shownImage = prevImage;
                    });
                }
            },
            nextImage() {
                let nextImage = this.shownImage + 1;
                if(nextImage > this.shownSlides.length - 1) {
                    this.disableAnimation();
                    this.$nextTick(() => {
                        this.shownImage = 0;
                        this.enableAnimation(true);
                    })
                } else {
                    this.enableAnimation();
                    this.$nextTick(() => {
                        this.shownImage = nextImage;
                    })
                }
            },
            disableAnimation(nextTick = false) {
                if(!nextTick) {
                    this.animate = false;
                }

                this.$nextTick(() => {
                    this.animate = false;
                })
            },
            enableAnimation(nextTick = false) {
                if(!nextTick) {
                    this.animate = true;
                }

                this.$nextTick(() => {
                    this.animate = true;
                })
            },
            getBackgroundImagetag(image) {
                return 'url(' + image + ')';
            },
            getImagetag(image) {
                return image;
            },
            readImgHeight() {
                if(this.thumbnail) {
                    return 'auto';
                }

                this.$nextTick(() => {
                    if(this.currentElement && this.currentElement.type == 'video') {
                        this.imgHeight = '29.2em';
                    } else {
                        this.imgHeight = (this.$refs.imgElements && this.$refs.imgElements[this.shownImage]) ? this.$refs.imgElements[this.shownImage].clientHeight + 'px' : 'auto';
                    }
                });
            },
        },
        computed: {
            currentElement() {
                return (this.shownSlides[this.shownImage]) ? this.shownSlides[this.shownImage] : null;  
            },
            heliSlidesIdx() {
                return this.slideList.filter(({type}) => type == 'video').map((slide) => {
                    return this.slideList.indexOf(slide);
                })
            },
            shownSlides() {
                let thumbnailMode = this.thumbnail;
                return this.slideList.filter(({type}) => {
                    return (thumbnailMode) ? type == 'image' : true;
                });
            },
            slideList() {
                let slides = [ ];

                if(Array.isArray(this.images)) {
                    slides = slides.concat(this.images.map(({image, description}) => {
                        return {
                            image,
                            description,
                            type: 'image'
                        }
                    }));
                }


                if(Array.isArray(this.videos) && this.videos.length) {
                    slides = slides.concat(this.videos.map((video) => {
                        return {
                            ...video,
                            image: video.thumbnail,
                            type: 'video'
                        }
                    }));
                }

                return slides;
            },
            hasDescriptions() {
                return this.slideList.filter(({description}) => description).length > 0 ? true  : false;
            }
        },
        components: {
            Carousel,
            Slide
        }
    }
</script>